<template>
  <v-container fluid>
    <v-row>
      <v-col cols="6">
        <v-card>
          <v-card-title>Bieżąca wizyta</v-card-title>
          <v-container fluid>
            <v-row>
              <v-col cols="6">
                <v-text-field prepend-icon="fa-calendar-alt" readonly label="Data wizyty"
                  :value="formattedDate"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field prepend-icon="fa-clock" readonly label="Godzina" :value="formattedTime"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field readonly label="Imię" v-model="details.clientName"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field readonly label="Nazwisko" v-model="details.clientSurname"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field readonly label="PESEL" v-model="details.pesel"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field readonly label="Telefon" v-model="details.phone"></v-text-field>
              </v-col>
              <v-col cols="6" v-if="details.representativeName">
                <v-text-field readonly label="Opiekun" v-model="details.representativeName"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field readonly label="Terapeuta przypisany do pacjenta"
                  v-model="details.therapistAssigned"></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="details.zabiegId && details.zabiegId > 0">
              <v-col cols="6">
                <v-text-field readonly label="Zabieg" v-model="details.zabiegNazwa"></v-text-field>
              </v-col>
              <v-col cols="6" v-if="details.zabiegPodtypId && details.zabiegPodtypId > 0">
                <v-text-field readonly label="Podtyp zabiegu" v-model="details.podTypZabieguNazwa"></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="details.typyWizytTerapeuty">
              <v-col cols="6">
                <v-select :items="filteredtypywizyt" item-text="nazwa" label="Typ wizyty"
                  placeholder="Wybierz typ wizyty..." v-model="wybrany_typ_wizyty" :disabled="details.status >= 2"
                  return-object clearable></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field label="Data urodzenia" :value="birthDate ? birthDate.toLocaleDateString() : 'Nieznana'"
                  readonly></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field label="Wiek" :value="age !== null ? age + ' lat' : 'Nieznany'" readonly></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea outlined readonly label="Uwagi" v-model="details.visitNotes"></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card>
          <v-card-title>Poprzednia wizyta </v-card-title>

          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <TherapistPreviousVisit :id="details.visitId" @visitHistory="showVisitHistory = true">
                </TherapistPreviousVisit>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <v-card style="margin-top:30px" v-if="$can('do', 'POKO_Klienci_Choroby')">
          <v-card-title>Alergie</v-card-title>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <ClientDiseasesICD :clientid="details.patientId" type="1"></ClientDiseasesICD>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="$can('do', 'POKO_Klienci_Choroby')">
      <v-col cols="12">
        <v-card style="margin-top:30px">
          <v-card-title>Choroby</v-card-title>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <ClientDiseasesICD :clientid="details.patientId" type="0"></ClientDiseasesICD>
              </v-col>
            </v-row>

          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-if="showVisitHistory" v-model="showVisitHistory" fullscreen>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="showVisitHistory = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
          <v-toolbar-title>Historia wizyt</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <MedicalVisitHistory :clientid="details.patientId" :onlyclosed="false"></MedicalVisitHistory>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import * as dayjs from "dayjs";
import TherapistPreviousVisit from "./TherapistPreviousVisit";
import MedicalVisitHistory from "../clients/MedicalVisitHistory";
import ClientDiseasesICD from "../clients/ClientDiseasesICD";
import { visitService } from "@/services";
import swal from "sweetalert";

export default {
  name: "TherapistVisitGeneralDetails",
  components: { ClientDiseasesICD, MedicalVisitHistory, TherapistPreviousVisit },
  props: ["details"],
  computed: {
    formattedDate() {
      if (this.details.startTime) {
        return dayjs(this.details.startTime).format('DD-MM-YYYY')
      }
      else {
        return ''
      }
    },
    formattedTime() {
      if (this.details.startTime && this.details.endTime) {
        return dayjs(this.details.startTime).format('HH:mm') + ' - ' + dayjs(this.details.endTime).format('HH:mm')
      }
      else {
        return ''
      }
    },
    filteredtypywizyt: function () {
      if (this.details.typyWizytTerapeuty != null) {
        let lst = []
        lst = this.details.typyWizytTerapeuty.map(obj => ({ ...obj, disabled: !obj.aktywna }))
        return lst
      }
      return []
    },
  },
  mounted() {
    if (this.filteredtypywizyt.length > 0) {
      let wybrany = this.filteredtypywizyt.find(x => x.id == this.details.typWizytyTerapeutyId)
      if (wybrany)
        this.wybrany_typ_wizyty = wybrany
      this.poprzedni_typ = wybrany
    }
    this.calculateBirthDateAndAge(this.details.pesel)
  },
  data() {
    return {
      showVisitHistory: false,
      hideActions: false,
      wybrany_typ_wizyty: null,
      poprzedni_typ: null,
      birthDate: null,
      age: null,
    }
  },
  methods: {
    calculateBirthDateAndAge(pesel) {
      if (!/^\d{11}$/.test(pesel)) {
        this.birthDate = null;
        this.age = null;
        return;
      }

      const yearBase = parseInt(pesel.substring(0, 2), 10);
      const month = parseInt(pesel.substring(2, 4), 10);
      const day = parseInt(pesel.substring(4, 6), 10);

      let year;
      if (month > 80) {
        year = 1800 + yearBase;
      } else if (month > 60) {
        year = 2200 + yearBase;
      } else if (month > 40) {
        year = 2100 + yearBase;
      } else if (month > 20) {
        year = 2000 + yearBase;
      } else {
        year = 1900 + yearBase;
      }

      const correctedMonth = month % 20; // Usunięcie przesunięcia wieku
      this.birthDate = new Date(year, correctedMonth - 1, day);

      const today = new Date();
      this.age = today.getFullYear() - year;
      if (
        today.getMonth() < correctedMonth - 1 ||
        (today.getMonth() === correctedMonth - 1 && today.getDate() < day)
      ) {
        this.age--;
      }
    },
    showError(close, text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        this.loading = false;
        if (close) {
          this.$emit("close");
        }
      });
    },
    checkVisitTimeTypWizytyTerapeuty(start, end) {
      visitService.CheckVisitTimeStatus({
        dateStart: start,
        dateEnd: end,
        zabiegi: false,
        visit_id: this.details.visitId
      }).then(resp => {
        if (resp && resp.data && resp.data.result) {
          let result = resp.data.result

          if (result.therapistCheck && result.therapistCheck.length > 0) {
            let found = null
            result.therapistCheck.forEach(itm => {
              if (itm.therapistId == this.details.therapistId) {
                found = itm
              }
            })
            if (found != null) {
              this.showError(false, "Uwaga ten typ wizyty koliduje czasowo z twoim kalendarzem")
              this.wybrany_typ_wizyty = this.poprzedni_typ
            }
            else {
              this.$emit('typwizyty', this.wybrany_typ_wizyty)
              this.poprzedni_typ = this.wybrany_typ_wizyty
            }
          }

        }
      }).catch(() => {
        this.showError(false, "Błąd sprawdzania daty i godziny");
      })

    }
  },
  watch: {
    wybrany_typ_wizyty: function (typ, old) {

      if (typ == null) return
      if (typ.dlugosc_wizyty > 0) {
        if (this.details.startTime != null) {

          let start = dayjs(this.details.startTime).format("YYYY-MM-DD HH:mm")
          let end = null


          end = dayjs(this.details.startTime)
            .add(typ.dlugosc_wizyty, "minute")
            .format("YYYY-MM-DD HH:mm")
          this.checkVisitTimeTypWizytyTerapeuty(start, end)
        }
      }
    }
  }

}
</script>

<style scoped></style>